import { CheckCircle2, AlertTriangle, Calendar } from "lucide-react";
import { getAirportDetails } from "@/data/airportDetails";

interface QuickStatsProps {
  airportCode: string;
}

export const QuickStats = ({ airportCode }: QuickStatsProps) => {
  const details = getAirportDetails(airportCode);

  const bestTime = "10-11 AM";
  const bestWait = "~6 min";
  const avoidTime = details?.peakHours.morning || "5-7 AM";
  const avoidWait = "25+ min";
  const busiestDays = details?.peakHours.busiestDays?.slice(0, 3).join(", ") || "Mon, Thu, Fri";

  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-3">
      <div className="bg-success/5 border border-success/20 rounded-xl p-3 text-center">
        <CheckCircle2 className="h-4 w-4 text-success mx-auto mb-1" />
        <p className="text-xs text-muted-foreground font-medium">Best Time</p>
        <p className="text-sm font-bold tabular-nums text-foreground mt-0.5">{bestTime}</p>
        <p className="text-xs text-success font-medium">{bestWait}</p>
      </div>
      <div className="bg-destructive/5 border border-destructive/20 rounded-xl p-3 text-center">
        <AlertTriangle className="h-4 w-4 text-destructive mx-auto mb-1" />
        <p className="text-xs text-muted-foreground font-medium">Avoid</p>
        <p className="text-sm font-bold tabular-nums text-foreground mt-0.5">{avoidTime}</p>
        <p className="text-xs text-destructive font-medium">{avoidWait}</p>
      </div>
      <div className="bg-primary/5 border border-primary/20 rounded-xl p-3 text-center">
        <Calendar className="h-4 w-4 text-primary mx-auto mb-1" />
        <p className="text-xs text-muted-foreground font-medium">Busiest Days</p>
        <p className="text-sm font-bold tabular-nums text-foreground mt-0.5">{busiestDays}</p>
        <p className="text-xs text-muted-foreground font-medium">Plan extra time</p>
      </div>
    </div>
  );
};
